import { Contents } from '../contents/types'

const cacheKeys = {
  all: ['interests'],
  list: () => [...cacheKeys.all, 'list'],
  byContentType: (type: Contents.Type) => [...cacheKeys.list(), { type }]
}

export default {
  endpoint: '/networks/interests',
  cacheKeys
}
